import { TourState } from '../models/interfaces'

/**
 * Estado inicial del módulo de tour
 */
export const state: TourState = {
  activeTour: null,
  currentStepIndex: 0,
  isActive: false,
  tourHistory: [],
  isTourEnabled: true,
}
